export const getDifference = (difference: number): string => {
  if (difference > 0) return `+${difference.toFixed(2)}%`;
  if (difference < 0) return `${difference.toFixed(2)}%`;
  return "";
};
